import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent {
}



// WEBPACK FOOTER //
// /builds/ulalachef/ulalachef-dashboard/src/app/components/app/app.component.ts